"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubSectionHeader = exports.BasketSection = void 0;
var _mui = require("@ori-ui/mui");
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
const Section = (0, _mui.styled)('div')(({
  ownerState: {
    isSmall,
    mdMaxWidth
  },
  theme
}) => ({
  boxSizing: 'border-box',
  overflow: 'hidden',
  width: '100%',
  margin: 0,
  padding: `0 ${_constants.XS_OUTER_PADDING}px`,
  background: theme.palette.background.paper,
  ...(isSmall && {
    maxWidth: _constants.SMALL_SECTION_WIDTH
  }),
  ...(!isSmall && {
    [theme.breakpoints.up('sm')]: {
      padding: `0 ${_constants.SM_OUTER_PADDING}px`,
      margin: '0 auto',
      borderRadius: theme.shape.largeComponentRadius,
      maxWidth: `${theme.breakpoints.values.md - 1 - 2 * _constants.SM_OUTER_PADDING}px`
    },
    [theme.breakpoints.up('md')]: {
      padding: `0 ${_constants.MD_OUTER_PADDING}px`,
      maxWidth: mdMaxWidth
    }
  })
}));
const SectionHeader = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  padding: theme.spacing(7, 0, 0, 0)
}));
const SubSectionHeader = exports.SubSectionHeader = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  padding: theme.spacing(3, 0, 0, 0),
  fontWeight: 'bold'
}));
const BasketSection = ({
  children,
  isSmall,
  overrideMdMaxWidth,
  headingComponent = 'h2',
  testId,
  title
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Section, {
  "data-testid": testId ?? 'basket-section',
  ownerState: {
    isSmall: isSmall ?? false,
    mdMaxWidth: overrideMdMaxWidth ?? '100%'
  },
  children: [(0, _tsUtils.isNonNullable)(title) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SectionHeader, {
    variant: "h6",
    component: headingComponent,
    children: title
  }) : null, children]
});
exports.BasketSection = BasketSection;
